import '../scss/style.scss';
import './modules/app-utils';
import Collapse from 'bootstrap/js/dist/collapse' // No need to init

import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';

import FlexibleSlider from  "./modules/flexible-slider";
import FlexiblesAnchors from  "./modules/flexibles-anchors";
import RelatedArticles from  "./modules/related-articles";
import RelatedNews from  "./modules/related-news";
import RelatedJobs from  "./modules/related-jobs";
import AddToCalendar from "./modules/add-to-calendar.js";
import Marquee from "./modules/marquee";
import SectorsList from "./modules/sectors-list.js";
import SliderVideo from "./modules/slider-video.js";
import FormationsList from "./modules/formations-list.js";
import Toolbox from "./modules/toolbox.js";
import Video from "./modules/video.js";
import VideosSnap from "./modules/videos-snap.js";
import PushVideoJob from "./modules/push-video-job.js";
import MovingSectors from "./modules/moving-sectors.js";
import Header from "./modules/header.js";
import PopinVideo from "./modules/popin-video.js";
import SelectCheckbox from "./modules/select-checkbox";
import FrontPagination from "./modules/front-pagination";
import CustomSelect from "./modules/custom-select.js";
import DateInput from "./modules/date-input.js";
import HourInput from "./modules/hour-input.js";
import InputControlDisable from "./modules/input-control-disable";
import InputUpload from "./modules/input-upload.js";
import FormSubmitEvent from "./modules/form-submit-event.js";
import InputQuill from "./modules/input-quill.js";
import InputAddress from "./modules/input-address.js";
import Captcha from "./modules/captcha.js";
import MapsEventsRmc from "./modules/maps-events-rmc.js";
import SearchEventsRmc from './modules/search-events-rmc';
import CustomFacetCalendar from "./modules/custom-facet-calendar.js";
import EventsRmc from "./modules/events-rmc.js";

window.addEventListener('load', () => {
    document.body.classList.add('css-animation-ready'); // Wait for the DOM to be fully loaded (with fonts), to run animations (wrong width if font not loaded for example)
})

app.domReady(() => {

    const els = {
        _flexibleSlider: document.querySelectorAll('.js-flexible-slider'),
        _flexiblesAnchors: document.querySelectorAll('.js-flexibles-anchors'),
        _relatedArticles: document.querySelectorAll('.js-related-articles'),
        _relatedJobs: document.querySelectorAll('.js-related-jobs'),
        _relatedNews: document.querySelectorAll('.js-related-news'),
        _addToCalendars: document.querySelectorAll('.js-add-to-calendar'),
        _marquee: document.querySelectorAll('.js-marquee'),
        _sectorsList: document.querySelectorAll('.js-sectors-list'),
        _sliderVideo: document.querySelectorAll('.js-slider-video'),
        _formationsList: document.querySelectorAll('.js-formations-list'),
        _toolBox: document.querySelectorAll('.js-toolbox'),
        _videos: document.querySelectorAll('.js-video'),
        _videosSnap: document.querySelectorAll('.js-videos-snap'),
        _pushVideoJob: document.querySelectorAll('.js-push-video-job'),
        _movingSectors: document.querySelectorAll('.js-moving-sectors'),
        _selectCheckbox: document.querySelectorAll('.js-select-checkbox'),
        _customSelects: document.querySelectorAll('.js-custom-select'),
        _dateInput: document.querySelectorAll('.js-date-input'),
        _inputControlDisables: document.querySelectorAll('.js-input-control-disable'),
        _hourInputs: document.querySelectorAll('.js-hour-input'),
        _inputUpload: document.querySelectorAll('.js-input-upload'),
        _formSubmitEvent: document.querySelectorAll('.js-form-submit-event'),
        _inputQuills: document.querySelectorAll('.js-input-quill'),
        _inputAddress: document.querySelectorAll('.js-input-address'),
        _captchas: document.querySelectorAll('.js-captcha'),
        _mapEventsRmc: document.querySelectorAll('.js-maps-events-rmc'),
        _searchEventsRmc: document.querySelectorAll('.js-search-events-rmc'),
        _customFacetCalendars: document.querySelectorAll('.js-custom-facet-calendar'),
        _eventsRmc: document.querySelectorAll('.js-events-rmc'),
    };
    
    new Header();

    new PopinVideo();
    
    if(els._flexibleSlider.length){
        [...els._flexibleSlider].map((el) => {
            new FlexibleSlider(el);
        });
    }
    

    if(els._flexiblesAnchors.length){
        [...els._flexiblesAnchors].map((el) => {
            new FlexiblesAnchors(el);
        });
    }

    if(els._relatedArticles.length){
        [...els._relatedArticles].map((el) => {
            new RelatedArticles(el);
        });
    }

    if(els._relatedNews.length){
        [...els._relatedNews].map((el) => {
            new RelatedNews(el);
        });
    }
    
    if(els._relatedJobs.length){
        [...els._relatedJobs].map((el) => {
            new RelatedJobs(el);
        });
    }
    
    if(els._addToCalendars.length){
        [...els._addToCalendars].map((el) => {
            new AddToCalendar(el);
        });
    }
    
    if(els._marquee.length){
        [...els._marquee].map((el) => {
            new Marquee(el);
        });
    }

    if(els._sectorsList.length){
        [...els._sectorsList].map((el) => {
            new SectorsList(el);
        });
    }

    if(els._sliderVideo.length){
        [...els._sliderVideo].map((el) => {
            new SliderVideo(el);
        });
    }

    if(els._formationsList.length){
        [...els._formationsList].map((el) => {
            new FormationsList(el);
        });
    }

    if(els._toolBox.length){
        [...els._toolBox].map((el) => {
            new Toolbox(el);
        });
    }

    if(els._videos.length){
        [...els._videos].map((el) => {
            new Video(el);
        });
    }

    if(els._videosSnap.length){
        [...els._videosSnap].map((el) => {
            new VideosSnap(el);
        });
    }

    if(els._pushVideoJob.length){
        [...els._pushVideoJob].map((el) => {
            new PushVideoJob(el);
        });
    }

    if(els._movingSectors.length){
        [...els._movingSectors].map((el) => {
            new MovingSectors(el);
        });
    }

    if(els._selectCheckbox.length){
        [...els._selectCheckbox].map((el) => {
            new SelectCheckbox(el);
        });
    }

    if(els._customSelects.length){
        [...els._customSelects].map((el) => {
            new CustomSelect(el);
        });
    }

    if(els._dateInput.length){
        [...els._dateInput].map((el) => {
            new DateInput(el);
        });
    }

    if(els._hourInputs.length){
        [...els._hourInputs].map((el) => {
            new HourInput(el);
        });
    }

    if(els._inputControlDisables.length){
        [...els._inputControlDisables].map((el) => {
            new InputControlDisable(el);
        });
    }

    if(els._inputUpload.length){
        [...els._inputUpload].map((el) => {
            new InputUpload(el);
        });
    }

    if(els._formSubmitEvent.length){
        [...els._formSubmitEvent].map((el) => {
            new FormSubmitEvent(el);
        });
    }

    if(els._inputQuills.length){
        [...els._inputQuills].map((el) => {
            new InputQuill(el);
        });
    }

    if(els._inputAddress.length){
        [...els._inputAddress].map((el) => {
            new InputAddress(el);
        });
    }

    if(els._captchas.length){
        [...els._captchas].map((el) => {
            new Captcha(el);
        });
    }

    if(els._customFacetCalendars.length){
        [...els._customFacetCalendars].map((el) => {
            new CustomFacetCalendar(el);
        });
    }

    if(els._mapEventsRmc.length){
        [...els._mapEventsRmc].map((el) => {
            new MapsEventsRmc(el);
        });
    }

    if(els._searchEventsRmc.length){
        [...els._searchEventsRmc].map((el) => {
            new SearchEventsRmc(el);
        });
    }

    if(els._eventsRmc.length){
        [...els._eventsRmc].map((el) => {
            new EventsRmc(el);
        });
    }
    
    document.addEventListener('facetwp-loaded', () => {
        // Video 
        let _videos = document.querySelectorAll('.js-video');
        [..._videos].map((el) => {
           if(!el.isInit){
               new Video(el);
           } 
        });
        let _videoSnap = document.querySelector('.js-videos-snap');
        if(_videoSnap){
            new VideosSnap(_videoSnap);
        }
        //Front pagination
        let _frontPaginations = document.querySelectorAll('.js-front-pagination');
        if(_frontPaginations.length){
            [..._frontPaginations].map((el) => {
                new FrontPagination(el);
            });   
        }
        //Calendars 
        let _addToCalendars = document.querySelectorAll('.js-add-to-calendar');
        if(_addToCalendars.length){
            [..._addToCalendars].map((el) => {
                if(!el.isInit){
                    new AddToCalendar(el);
                }
            });
        }
        
    });
    
    document.addEventListener('click', (e) => {
       if(e.target.classList.contains('js-cookies-consent-youtube')){
           console.log('here');
           window.BorlabsCookie.Consents.addConsent('youtube', 'external-media');
       } 
    });
});